<template>
  
  <div id="quotation-product-detail" class="ui large modal quotation-product-modal">

    <div class="ui header">
      Detalhes do Produto
    </div>

    <div class="content modal-content-scrolling">

      <div v-if="item" class="ui grid">

        <div class="ten wide computer sixteen wide tablet sixteen wide mobile column">

          <div class="ui segment">
            <h4 class="ui dividing header">
              Produto 
              <span v-if="isObject(item.status.label)" class="ui small label">
                <i :class="[isObject(item.status.icon) ? item.status.icon.__old : item.status.icon] + ' ' + [isObject(item.status.color) ? item.status.color.__old : item.status.color]"></i>
                {{ item.status.label.__old }}
              </span>
              <p v-if="isObject(item.status.label)"></p>
              <span class="ui small label">
                <i :class="[isObject(item.status.icon) ? item.status.icon.__new : item.status.icon] + ' ' + [isObject(item.status.color) ? item.status.color.__new : item.status.color]"></i>
                {{ isObject(item.status.label) ? item.status.label.__new : item.status.label }}
              </span>
            </h4>
            <form class="ui form">
              <div class="fields">
                <div class="one wide field">
                  <label class="form-label">Item</label>
                  <span v-if="isObject(item.item)">Antes: {{ item.item.__old }}</span>
                  <p v-if="isObject(item.item)"></p>
                  <span>{{ isObject(item.item) ? item.item.__new : item.item }}</span>
                </div>
                <div class="fourteen wide field">
                  <label class="form-label">Descrição</label>
                  <span v-if="isObject(item.description)">Antes: {{ item.description.__old }}</span>
                  <p v-if="isObject(item.description)"></p>
                  <span>{{ isObject(item.description) ? item.description.__new : item.description }}</span>
                </div>
              </div>
              <div class="fields">
                <div class="four wide field">
                  <label class="form-label">Preço Padrão</label>
                  <div class="ui icon input">
                    <span v-if="isObject(item.stdPrice) || isObject(item.minPrice)" class="clickable product-details-popup" :data-html="[isObject(stdPricePopupHtml) ? stdPricePopupHtml.__old || stdPricePopupHtml : stdPricePopupHtml]">
                      Antes: R$ {{ $formatCurrencyWith4Decimals(isObject(item.stdPrice) ? item.stdPrice.__old : (isObject(item.minPrice) ? item.minPrice.__old : (item.stdPrice || item.minPrice))) }}
                      <i class="search plus grey icon m-l-5"></i>
                    </span>
                    <p v-if="isObject(item.stdPrice) || isObject(item.minPrice)"></p>
                    <span class="clickable product-details-popup" :data-html="[isObject(stdPricePopupHtml) ? stdPricePopupHtml.__new : stdPricePopupHtml]">
                      R$ {{ isObject(item.stdPrice) ? $formatCurrencyWith4Decimals(item.stdPrice.__new) : (isObject(item.minPrice) ? $formatCurrencyWith4Decimals(item.stdPrice || item.minPrice.__new) : $formatCurrencyWith4Decimals(item.stdPrice || item.minPrice)) }}
                      <i class="search plus grey icon m-l-5"></i>
                    </span>
                  </div>
                </div>
                <div class="four wide field">
                  <label class="form-label">
                    Quant. Total 
                    <i v-if="isObject(item.quantityAlert) && item.quantityAlert.__old" class="exclamation circle red icon"></i>
                    <i v-else-if="isObject(item.quantityAlert) && !item.quantityAlert.__old" class="check circle green icon"></i>      
                    <i v-if="isObject(item.quantityAlert) && item.quantityAlert.__new" class="exclamation circle red icon"></i>
                    <i v-else-if="!isObject(item.quantityAlert) && item.quantityAlert" class="exclamation circle red icon"></i>
                    <i v-else class="check circle green icon"></i>
                  </label>
                  <span v-if="isObject(item.quantity)" :class="{ 'red text': item.quantityAlert.__old ? item.quantityAlert.__old : item.quantityAlert }">Antes: {{ $formatInteger(item.quantity.__old) }}</span>
                  <p v-if="isObject(item.quantity)"></p>
                  <span :class="{ 'red text': isObject(item.quantityAlert) ? item.quantityAlert.__new : item.quantityAlert }">{{ isObject(item.quantity) ? $formatInteger(item.quantity.__new) : $formatInteger(item.quantity) }}</span>
                </div>
                <div class="four wide field">
                  <label class="form-label">
                    Preço Sugerido
                    <i v-if="isObject(item.sugPriceAlert) && item.sugPriceAlert.__old" class="exclamation circle red icon"></i>
                    <i v-else-if="isObject(item.sugPriceAlert) && !item.sugPriceAlert.__old" class="check circle green icon"></i>
                    <i v-if="isObject(item.sugPriceAlert) && item.sugPriceAlert.__new" class="exclamation circle red icon"></i>
                    <i v-else-if="!isObject(item.sugPriceAlert) && item.sugPriceAlert" class="exclamation circle red icon"></i>
                    <i v-else class="check circle green icon"></i>
                  </label>
                  <span v-if="isObject(item.sugPrice)" :class="{ 'red text': item.sugPriceAlert.__old ? item.sugPriceAlert.__old : item.sugPriceAlert }">Antes: R$ {{ $formatCurrencyWith4Decimals(item.sugPrice.__old) }}</span>
                  <p v-if="isObject(item.sugPrice)"></p>
                  <span :class="{ 'red text': isObject(item.sugPriceAlert) ? item.sugPriceAlert.__new : item.sugPriceAlert }">R$ {{ isObject(item.sugPrice) ? $formatCurrencyWith4Decimals(item.sugPrice.__new) : $formatCurrencyWith4Decimals(item.sugPrice) }}</span>
                </div>
                <div class="four wide field">
                  <label class="form-label">Total Sugerido</label>
                  <span v-if="isObject(item.sugTotal)">Antes: R$ {{ $formatCurrency(item.sugTotal.__old) }}</span>
                  <p v-if="isObject(item.sugTotal)"></p>
                  <span>R$ {{ isObject(item.sugTotal) ? $formatCurrency(item.sugTotal.__new) : $formatCurrency(item.sugTotal) }}</span>
                </div>                
              </div>
              <div class="fields">
                <div class="four wide field">
                  <label class="form-label">Desconto Sugerido</label>
                  <span v-if="isObject(item.sugDiscount)">Antes: {{ item.sugDiscount.__old }}</span>
                  <p v-if="isObject(item.sugDiscount)"></p>
                  <span v-html="formatDiscount(isObject(item.sugDiscount) ? item.sugDiscount.__new : item.sugDiscount, 'sug')"></span>
                </div>
                <div class="four wide field">
                  <label class="form-label">Comissão Sugerida</label>
                  <span v-if="isObject(item.sugCommission)">{{ $formatCurrency(item.sugCommission.__old) }} %</span>
                  <p v-if="isObject(item.sugCommission)"></p>
                  <span>{{ isObject(item.sugCommission) ? $formatCurrency(item.sugCommission.__new) : $formatCurrency(item.sugCommission) }} %</span>
                </div>
                <div class="four wide field">
                  <label class="form-label">
                    Preço Aprovado
                    <i v-if="isObject(item.appPriceAlert) && item.appPriceAlert.__old" class="exclamation circle red icon"></i>
                    <i v-else-if="isObject(item.appPriceAlert) && !item.appPriceAlert.__old" class="check circle green icon"></i>
                    <i v-if="isObject(item.appPriceAlert) && item.appPriceAlert.__new" class="exclamation circle red icon"></i>
                    <i v-else-if="!isObject(item.appPriceAlert) && item.appPriceAlert" class="exclamation circle red icon"></i>
                    <i v-else class="check circle green icon"></i>
                  </label>
                  <span v-if="isObject(item.appPriceAlert)" :class="{ 'red text': isObject(item.appPriceAlert) ? item.appPriceAlert.__old : item.appPriceAlert }">Antes: R$ {{ $formatCurrencyWith4Decimals(item.appPrice.__old) }}</span>
                  <p v-if="isObject(item.appPriceAlert)"></p>
                  <span :class="{ 'red text': isObject(item.appPriceAlert) ? item.appPriceAlert.__new : item.appPriceAlert }">R$ {{ isObject(item.appPrice) ? $formatCurrencyWith4Decimals(item.appPrice.__new) : $formatCurrencyWith4Decimals(item.appPrice) }}</span>
                </div>
                <div class="four wide field">
                  <label class="form-label">Total Aprovado</label>
                  <span v-if="isObject(item.appTotal)">Antes: R$ {{ $formatCurrency(item.appTotal.__old) }}</span>
                  <p v-if="isObject(item.appTotal)"></p>
                  <span>R$ {{ isObject(item.appTotal) ? $formatCurrency(item.appTotal.__new) : $formatCurrency(item.appTotal) }}</span>
                </div>
              </div>
              <div class="fields">
                <div class="four wide field">
                  <label class="form-label">Desconto Aprovado</label>
                  <span v-if="isObject(item.appDiscount)">Antes: {{ item.appDiscount.__old }}</span>
                  <p v-if="isObject(item.appDiscount)"></p>
                  <span v-html="formatDiscount(isObject(item.appDiscount) ? item.appDiscount.__new : item.appDiscount, 'app')"></span>
                </div>
                <div class="four wide field">
                  <label class="form-label">Comissão Aprovada</label>
                  <span v-if="isObject(item.appCommission)">Antes: {{ $formatCurrency(item.appCommission.__old) }} %</span>
                  <p v-if="isObject(item.appCommission)"></p>
                  <span>{{ isObject(item.appCommission) ? $formatCurrency(item.appCommission.__new) : $formatCurrency(item.appCommission) }} %</span>
                </div>
                <div class="four wide field">
                  <label class="form-label">Diferença</label>
                  <span v-if="isObject(item.priceDiff)">Antes: {{ $formatCurrency(item.priceDiff.__old) }} %</span>
                  <p v-if="isObject(item.priceDiff)"></p>
                  <span>{{ isObject(item.priceDiff) ? $formatCurrency(item.priceDiff.__new) : $formatCurrency(item.priceDiff) }} %</span>
                </div>
                <div v-if="canSeeRg()" class="four wide field">
                  <label class="form-label">RG Aprovado</label>
                  <div v-if="isObject(item.appRg)" class="ui icon input">
                    <span v-if="isObject(item.appRg)" class="clickable product-details-popup" :data-html="isObject(rgPopupHtml) ? rgPopupHtml.__old : rgPopupHtml">
                      Antes: {{ $formatCurrency(item.appRg.__old) }}
                      <i class="search plus grey icon m-l-5"></i>
                    </span>
                  </div>
                  <p v-if="isObject(item.appRg)"></p>
                  <div class="ui icon input">
                    <span class="clickable product-details-popup" :data-html="isObject(rgPopupHtml) ? rgPopupHtml.__new : rgPopupHtml">
                      {{ isObject(item.appRg) ? $formatCurrency(item.appRg.__new) : $formatCurrency(item.appRg) }}
                      <i class="search plus grey icon m-l-5"></i>
                    </span>
                  </div>
                </div>                
              </div>
              <div class="fields">
                <div class="four wide field">
                  <label class="form-label">Pedido Cliente</label>
                  <span v-if="isObject(item.customerSalesOrder)">Antes: {{ item.customerSalesOrder.__old }}</span>
                  <p v-if="isObject(item.customerSalesOrder)"></p>
                  <span>{{ isObject(item.customerSalesOrder) ? item.customerSalesOrder.__new : item.customerSalesOrder }}</span>
                </div>
                <div class="ten wide field">
                  <label class="form-label">Item Ped. Cliente</label>
                  <span v-if="isObject(item.itemCustomerSalesOrder)">Antes: {{ item.itemCustomerSalesOrder.__old }}</span>
                  <p v-if="isObject(item.itemCustomerSalesOrder)"></p>
                  <span>{{ isObject(item.itemCustomerSalesOrder) ? item.itemCustomerSalesOrder.__new : item.itemCustomerSalesOrder }}</span>
                </div>
              </div>
            </form>
          </div>

        </div>

        <div class="six wide computer sixteen wide tablet sixteen wide mobile column">

          <div class="ui segment">
            <h4 class="ui dividing header">Cores</h4>
            <table class="ui very basic selectable celled table">
              <thead class="desktop-only">
                <tr>
                  <th>Cor</th>
                  <th>Quantidade</th>
                  <th>Total</th>
                  <th>P. O. Shipment</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="color in item.colors">
                  <td v-if="isObject(color.colorName)">
                    Antes: {{ color.colorName.__old }}                     
                    <i v-if="isObject(color.requireApproval) && color.requireApproval.__old" class="clickable exclamation circle red icon product-details-popup" 
                      data-content="Requer aprovação" data-variation="inverted"></i> 
                    <i v-else-if="color.requireApproval" class="clickable exclamation circle red icon product-details-popup" 
                    data-content="Requer aprovação" data-variation="inverted"></i> 
                  </td>
                  <td>
                    {{ isObject(color.colorName) ? color.colorName.__new : color.colorName }}                     
                    <i v-if="isObject(color.requireApproval) && color.requireApproval.__new" class="clickable exclamation circle red icon product-details-popup" 
                      data-content="Requer aprovação" data-variation="inverted"></i> 
                    <i v-else-if="color.requireApproval" class="clickable exclamation circle red icon product-details-popup" 
                    data-content="Requer aprovação" data-variation="inverted"></i> 
                  </td>
                  <td v-if="isObject(color.quantity)"><strong class="mobile-only">Quantidade: </strong>Antes: {{ isObject(color.quantity) ? $formatInteger(color.quantity.__old) : $formatInteger(color.quantity) }}</td>
                  <td><strong class="mobile-only">Quantidade: </strong>{{ isObject(color.quantity) ? $formatInteger(color.quantity.__new) : $formatInteger(color.quantity) }}</td>
                  <td v-if="isObject(color.total)"><strong class="mobile-only">Total: </strong>Antes: {{ isObject(color.total) ? $formatInteger(color.total.__new) : $formatInteger(color.total) }}</td>
                  <td><strong class="mobile-only">Total: </strong>{{ isObject(color.total) ? $formatInteger(color.total.__new) : $formatInteger(color.total) }}</td>
                  <td v-if="isObject(color.poShip)"><strong class="mobile-only">Total: </strong>Antes: {{ isObject(color.poShip) ? $formatInteger(color.poShip.__new) : $formatInteger(color.poShip) }}</td>
                  <td><strong class="mobile-only">P. O. Shipment: </strong>{{ isObject(color.poShip) ? $formatInteger(color.poShip.__new) : $formatInteger(color.poShip) }}</td>
                </tr>                
              </tbody>
            </table>
          </div>          

        </div>

      </div>

      <div v-if="reserve || loadingReserve" class="ui grid">

        <div class="ten wide computer sixteen wide tablet sixteen wide mobile column">

          <div class="ui segment" style="min-height: 200px;">
            <h4 class="ui dividing header">Reserva</h4>
            <div v-if="loadingReserve"><i class="spinner circle loading blue icon"></i> Carregando ...</div>
            <form v-if="reserve && !loadingReserve" class="ui form animated fadeIn">
              <div class="fields">
                <div class="four wide field">
                  <label class="form-label">Status</label>
                  <span v-if="reserve.isWaiting"><i class="clock yellow icon"></i> Pendente</span>
                  <span v-if="reserve.isConfirmed"><i class="check circle green icon"></i> Confirmada</span>
                  <span v-if="reserve.isExpired"><i class="exclamation circle icon"></i> Expirada</span>
                  <span v-if="reserve.isCanceled"><i class="times red icon"></i> Cancelada</span>
                </div>
                <div class="three wide field">
                  <label class="form-label">Filial</label>
                  <span>{{ reserve.balance.branch.name }}</span>
                </div>
                <div class="three wide field">
                  <label class="form-label">Número</label>
                  <span>{{ reserve.id }}</span>
                </div>
                <div class="three wide field">
                  <label class="form-label">Emissão</label>
                  <span>{{ $formatDate(reserve.date) }}</span>
                </div>
                <div class="three wide field">
                  <label class="form-label">Data Validade</label>
                  <span>{{ $formatDate(reserve.dateValid) }}</span>
                </div>
              </div>
              <div class="fields">
                <div class="four wide field">
                  <label class="form-label">Hora Validade</label>
                  <span>{{ reserve.timeValid }}</span>
                </div>
                <div class="twelve wide field">
                  <label class="form-label">Responsável</label>
                  <span>{{ reserve.userName }}</span>
                </div>
              </div>
            </form>
          </div>

        </div>

      </div>

    </div>

    <div class="actions">
      <button class="ui cancel basic button" @click="hide()">
        <i class="remove icon"></i>
        Sair
      </button>
    </div>

  </div>

</template>

<script>

  import { OppBalanceService, QuotationService } from "@/services"

  export default {

    data() {
      return {
        reserve: null,
        loadingReserve: false,
        branchReserve: '',
        idReserve: ''
      }
    },

    props: ["item"],

    computed: {

      stdPricePopupHtml() {

        let html = ""

        if (this.isObject(this.item.listPrice)) {
          html += `<div><strong>Preço de Tabela: </strong> Antes: R$ ${this.$formatCurrencyWith4Decimals(this.item.listPrice.__old)}</div>`
          html += `<div><strong>Preço de Tabela: </strong> R$ ${this.$formatCurrencyWith4Decimals(this.item.listPrice.__new)}</div>`
        } else {
          html += `<div><strong>Preço de Tabela: </strong> R$ ${this.$formatCurrencyWith4Decimals(this.item.listPrice)}</div>`
        }

        if (this.isObject(this.item.defDiscount)) {
          html += `<div class="m-t-5"><strong>Desc. Padrão: </strong> Antes: ${this.item.defDiscount.__old}</div>`
          html += `<div class="m-t-5"><strong>Desc. Padrão: </strong> ${this.item.defDiscount.__new}</div>`
        } else {
          html += `<div class="m-t-5"><strong>Desc. Padrão: </strong> ${this.item.defDiscount || ''}</div>`
        }

        return html
      },

      rgPopupHtml() {

        let html = ""

        if (this.isObject(this.item.minRg) || this.isObject(this.item.sugRg)) {
          if (this.isObject(this.item.minRg)) {
            html += `<div><strong>RG Mínimo: </strong> Antes: ${this.$formatCurrency(this.item.minRg.__old)}</div>`
            html += `<div><strong>RG Mínimo: </strong> ${this.$formatCurrency(this.item.minRg.__new)}</div>`
          } else {
            html += `<div><strong>RG Mínimo: </strong> ${this.$formatCurrency(this.item.minRg)}</div>`
          }
          
          if (this.isObject(this.item.sugRg)) {
            html += `<div class="m-t-5"><strong>RG Sugerido: </strong> Antes: ${this.$formatCurrency(this.item.sugRg.__old)}</div>`
            html += `<div class="m-t-5"><strong>RG Sugerido: </strong> ${this.$formatCurrency(this.item.sugRg.__new)}</div>`
          } else {
            html += `<div class="m-t-5"><strong>RG Sugerido: </strong> ${this.$formatCurrency(this.item.sugRg)}</div>`
          }
        } else {
          html += `<div><strong>RG Mínimo: </strong> ${this.$formatCurrency(this.item.minRg)}</div>`
          html += `<div class="m-t-5"><strong>RG Sugerido: </strong> ${this.$formatCurrency(this.item.sugRg)}</div>`
        }

        return html
      },
    },

    mounted() {
      $("#quotation-product-detail").modal({ 
        autofocus: false,
        onVisible: () => {
          
          if (this.item.idReserve)
            this.loadReserve()

          $(".product-details-popup").popup()
        },
      })      
    },
    
    beforeDestroy() {
      $(".quotation-product-modal").remove()
    },

    methods: {

      show() {                
        $("#quotation-product-detail").modal("show")    
      },

      hide() {
        this.reserve = null
        this.idReserve = ''
        $("#quotation-product-detail").modal("hide")    
      },

      canSeeRg() {
        return QuotationService.canSeeRg()
      },

      async loadReserve() {

        this.loadingReserve = true

        try {
          if (this.item.branchReserve.__new) {
            this.branchReserve = this.item.branchReserve.__new
            if (this.item.idReserve.__new)
              this.idReserve = this.item.idReserve.__new
          } else {
            this.branchReserve = this.item.branchReserve
            this.idReserve = this.item.idReserve
          }

          this.reserve = await OppBalanceService.getReserveById(this.branchReserve, this.idReserve)

          this.loadingReserve = false
          
        } catch (error) {
          
          this.loadingReserve = false
          this.$errorHandler(error)
        }
      },

      formatDiscount(discount, type) {
        // Mod20634-1: sempre exibir desconto. Numero negativo em vermelho.
        if (type === 'app') {
          const appPrice = this.isObject(this.item.appPrice) ? this.item.appPrice.__new : this.item.appPrice
          if (!appPrice) return ''
          const stdPrice = this.isObject(this.item.stdPrice) ? this.item.stdPrice.__new : this.item.stdPrice
          if (stdPrice && Number(appPrice) > Number(stdPrice)) {
            const n = Number(discount)
            if (!isNaN(n)) {
              return n < 0 ? `<span class="red text">${discount}</span>` : String(discount)
            }
          }
        }
        if (type === 'sug') {
          const sugPrice = this.isObject(this.item.sugPrice) ? this.item.sugPrice.__new : this.item.sugPrice
          const stdPrice = this.isObject(this.item.stdPrice) ? this.item.stdPrice.__new : this.item.stdPrice
          if (stdPrice && Number(sugPrice) > Number(stdPrice)) {
            const n = Number(discount)
            if (!isNaN(n)) {
              return n < 0 ? `<span class="red text">${discount}</span>` : String(discount)
            }
          }
        }
        const typedField = type === 'sug' ? 'sugDiscTyped' : 'appDiscTyped'
        const typed = this.isObject(this.item[typedField]) ? this.item[typedField].__new : this.item[typedField]
        if (typed) {
          return QuotationService.formatDiscountFromTyped(typed)
        }
        const card = this.isObject(this.item.discountCard) ? this.item.discountCard.__new : this.item.discountCard
        const additional = this.isObject(this.item.discountAdditional) ? this.item.discountAdditional.__new : this.item.discountAdditional
        const extra = this.isObject(this.item.discountExtra) ? this.item.discountExtra.__new : this.item.discountExtra
        if (card || additional || extra) {
          return QuotationService.formatDiscountBold(card, additional, extra)
        }
        const def = this.isObject(this.item.defDiscount) ? this.item.defDiscount.__new : this.item.defDiscount
        return QuotationService.formatDiscountWithDef(discount, def)
      },

      isObject(value) {
        if (typeof value == "object" && value != null) {
          return true
        }
        return false
      },
    },
  }

</script>

